import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

export const Header = () => {
  return (
    <HeaderContainer>
      <LogoContainer>
        <Logo src={ImageUtils.Logo} />
        <picture>
          <source srcSet={ImageUtils.LabelMobile} media="(max-width: 1000px)" />
          <img src={ImageUtils.Label} />
        </picture>
      </LogoContainer>
      <TableContainer>
        <HeaderRow>
          <HeaderCell></HeaderCell>
          <HeaderCell>
            <HeaderTitle>온라인 새틀라이트</HeaderTitle>
          </HeaderCell>
          <HeaderCell>
            <HeaderTitle>오프라인 이벤트</HeaderTitle>
          </HeaderCell>
        </HeaderRow>
        <Table>
          <colgroup>
            <col style={{ width: '10%' }} />
            <col style={{ width: '53%' }} />
            <col style={{ width: '37%' }} />
          </colgroup>
          <tbody>
            <tr>
              <TableTitle>700만 Step to 7000만</TableTitle>
              <TableCell1>
                2월 12일(목)~3월 20일(금)
                <br />
                매일 오후 12시, 1시, 2시
              </TableCell1>
              <TableCell1 rowSpan={3}>
                <strong>메인 이벤트</strong>
                <br />
                <strong>DAY1</strong>
                {` `}
                3월 21일(토){` `}
                <br />
                <strong>DAY2</strong> 3월 22일(일)
                <br />
                <br />
                <strong>사이드 이벤트</strong>
                <br />
                3월 22일(일)
              </TableCell1>
            </tr>
            <tr>
              <TableTitle>7000만 Step to 7억</TableTitle>
              <TableCell1>
                2월 12일(목)~3월 20일(금)
                <br />
                매일 오후 4시, 5시, 6시
              </TableCell1>
            </tr>
            <tr>
              <TableTitle>새틀라이트</TableTitle>
              <TableCell1>
                2월 12일(목)~3월 20일(금)
                <br />
                매일 오후 7시, 9시, 11시
              </TableCell1>
            </tr>
            <tr>
              <TableCell2>장소</TableCell2>
              <TableCell2>피망 쇼다운 홀덤 앱</TableCell2>
              <TableCell2>추후 공지</TableCell2>
            </tr>
          </tbody>
        </Table>
      </TableContainer>
    </HeaderContainer>
  );
};

const TableContainer = styled.div`
  position: relative;
  z-index: 1;
  max-width: 820px;
  margin: 0 auto;

  ${mobileQuery} {
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
  }
`;

const HeaderContainer = styled.header``;

const Logo = styled.img`
  position: relative;
  z-index: 1;
  width: 357px;
  margin-bottom: 16px;
  ${mobileQuery} {
    width: 191px;
    margin-bottom: 10px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding-top: 35px;
  position: relative;
  margin-bottom: 10px;
  z-index: 1;

  ${mobileQuery} {
    padding-top: 22px;
    margin-bottom: 5px;
    align-items: center;
    justify-content: center;
  }
`;

const Table = styled.table`
  width: 100%;
  text-align: left;
  margin-bottom: 25px;
  position: relative;

  ${mobileQuery} {
    margin-bottom: 0px;
  }
`;

const TableCell = styled.td`
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.05em;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.7);
  padding: 7px 9px 9px 9px;
  box-sizing: border-box;
  min-width: 120px;
  backdrop-filter: blur(9px);

  ${mobileQuery} {
    padding: 5px 0;
    min-width: 60px;
    line-height: 1.3;
    font-size: 13px;
  }
`;

const TableTitle = styled(TableCell)`
  color: #ea91a9;
  ${mobileQuery} {
    font-size: 11px;
  }
`;

const TableCell1 = styled(TableCell)`
  color: #ea91a9;

  strong {
    font-weight: 700;
    color: #ffd2de;
  }

  span {
    color: #ad6578;
  }
`;

const TableCell2 = styled(TableCell)`
  color: #ea91a9;

  ${mobileQuery} {
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  border-collapse: collapse;
`;

const HeaderCell = styled.div`
  background: rgba(187, 69, 99, 0.5);
  border-top: 2px solid rgba(250, 41, 124, 0.8);
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.8);
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    width: 10%; /* 첫 번째 빈 셀의 너비 조정 */
  }

  &:nth-child(2) {
    width: 53%; /* 두 번째, 세 번째 셀의 너비 */
  }

  &:nth-child(3) {
    width: 37%; /* 두 번째, 세 번째 셀의 너비 */
  }

  ${mobileQuery} {
    height: 24px;
    border-top: 1px solid rgba(250, 41, 124, 0.8);
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
  }
`;

const HeaderTitle = styled.h3`
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 16px;

  ${mobileQuery} {
    font-size: 13px;
  }
`;
